import { z } from "zod";

export const DischargeLetterAccidentSurgeryFormSchema = z.object({
  admission_findings: z.string().optional(),
  allergies: z.string().optional(),
  anamnesis: z.string().optional(),
  appointments: z.string().optional(),
  clinical_course: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_recommendations: z.string().optional(),
  ecg: z.string().optional(),
  further_findings: z.string().optional(),
  lab_results: z.string().optional(),
  medication_upon_discharge: z.string().optional(),
  parameters: z.string().optional(),
  social_anamnesis: z.string().optional(),
  therapy: z.string().optional(),
});
